export function shouldEndBrowserSession(status, pathname) {
  const normalizedPathname = String(pathname || "/").replace(/\/+$/, "") || "/";
  const isGuestOrderRoute =
    normalizedPathname === "/pos/guest-order" ||
    normalizedPathname.startsWith("/pos/guest-order/");
  const isServiceDisplayRoute =
    normalizedPathname === "/pos/service-display" ||
    normalizedPathname.startsWith("/pos/service-display/");

  return (
    status === 401 &&
    normalizedPathname !== "/" &&
    normalizedPathname !== "/login" &&
    !isGuestOrderRoute &&
    !isServiceDisplayRoute &&
    !normalizedPathname.startsWith("/reset-password") &&
    !normalizedPathname.startsWith("/accept-invitation")
  );
}

export function endRevokedBrowserSession(error, browserWindow = window) {
  if (
    !shouldEndBrowserSession(
      error?.response?.status,
      browserWindow?.location?.pathname
    )
  ) {
    return false;
  }

  const readAuthorization = (headers) => headers?.get?.("Authorization") ?? headers?.Authorization ?? headers?.authorization;
  const authorization = readAuthorization(error?.config?.headers) ?? readAuthorization(error?.response?.config?.headers);
  // A response for an earlier BU/login must not invalidate the current session.
  // Preserve legacy callers without request headers, which still rely on 401.
  if (authorization != null) {
    const match = /^Bearer\s+(.+)$/i.exec(String(authorization).trim());
    const currentToken = browserWindow.localStorage.getItem?.("palantir_token");
    if (!match || match[1].trim() !== currentToken) return false;
  }

  browserWindow.localStorage.removeItem("palantir_token");
  browserWindow.localStorage.removeItem("palantir_user");
  browserWindow.location.href = "/";
  return true;
}
